import { Link } from "react-router-dom";
import { allCategories, allTopics } from "@/utils/news";

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-mail-line", label: "邮箱" },
  { icon: "ri-rss-line", label: "订阅" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 border-t border-background-300 bg-primary-50">
      <div className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-black text-foreground-950">
                9
              </span>
              <span className="font-heading text-lg font-black tracking-wide text-foreground-950">
                911爆料
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              专注爆料新闻与深度事件分析，追踪社会热点、还原事件真相、传递独家信息。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {socials.map((item) => (
                <span
                  key={item.label}
                  title={item.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-primary-200 text-foreground-700 transition-colors hover:border-accent-500 hover:text-accent-400"
                >
                  <i className={item.icon} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">新闻分类</h4>
            <ul className="mt-4 space-y-2.5">
              {allCategories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="block text-sm text-foreground-600 transition-colors hover:text-accent-400"
                  >
                    {category.name}新闻
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">爆料专题</h4>
            <ul className="mt-4 space-y-2.5">
              {allTopics.map((topic) => (
                <li key={topic.id}>
                  <Link
                    to={`/topic/${topic.id}`}
                    className="block text-sm text-foreground-600 transition-colors hover:text-accent-400"
                  >
                    {topic.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">关于平台</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="block text-sm text-foreground-600 transition-colors hover:text-accent-400"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="block text-sm text-foreground-600 transition-colors hover:text-accent-400"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className="block text-sm text-foreground-600 transition-colors hover:text-accent-400"
                >
                  搜索爆料
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-200 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 911爆料 · 本站内容为演示数据，仅用于产品展示。</p>
          <p className="flex items-center gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
            理性看待爆料，一切以权威发布为准
          </p>
        </div>
      </div>
    </footer>
  );
}